var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-line"},[_c('img',{staticClass:"logo-el-login",attrs:{"src":require("../../assets/images/pages/login/logo_pc.png"),"alt":""}}),_c('span',{staticClass:"logo-r-text pc-title white-color"},[_vm._v("RRT-策略管理系统")])])
}]

export { render, staticRenderFns }